/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedDrawer from '@/components/WrappedDrawer'
import { createSystemAgent, updateSystemAgent } from '@/service/systemControl'
import AgentForm from './AgentForm'

function toIntOrOmit(v) {
  if (v === '' || v === null || v === undefined) return undefined
  const n = Number(v)
  return Number.isNaN(n) ? undefined : n
}

/**
 * 组装 POST/PUT body；可选字段为空则不提交
 */
function buildAgentBody(fields, isEdit) {
  const body = {
    account: String(fields.account || '').trim(),
    userName: String(fields.userName || '').trim(),
    type: Number(fields.type)
  }

  const optIntKeys = [
    'storeId',
    'provinceId',
    'cityId',
    'areaId',
    'departmentId',
    'positionId',
    'loginPermission',
    'state'
  ]
  optIntKeys.forEach((k) => {
    const x = toIntOrOmit(fields[k])
    if (x !== undefined) body[k] = x
  })

  ;['companyName', 'phone', 'qqOrWechat', 'address'].forEach((k) => {
    const s = fields[k]
    if (s != null && String(s).trim() !== '') {
      body[k] = String(s).trim()
    }
  })

  const pwd = fields.password
  if (!isEdit) {
    body.password = String(pwd || '').trim()
  } else if (pwd != null && String(pwd).trim() !== '') {
    body.password = String(pwd).trim()
  }

  return body
}

/**
 * 新建 / 编辑管理员：POST /system/agents、PUT /system/agents/{id}
 */
class AgentDrawer extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }

  static defaultProps = {
    actType: 'create',
    baseProps: {}
  }

  state = {
    drawerWidth:
      typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
        ? '100%'
        : 920
  }

  mediaQuery = null

  componentDidMount() {
    this.mediaQuery = window.matchMedia('(max-width: 767px)')
    this.applyDrawerWidth()
    this.mediaQuery.addEventListener('change', this.applyDrawerWidth)
  }

  componentWillUnmount() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener('change', this.applyDrawerWidth)
    }
  }

  applyDrawerWidth = () => {
    if (!this.mediaQuery) return
    this.setState({
      drawerWidth: this.mediaQuery.matches ? '100%' : 920
    })
  }

  handleOk = async (form) => {
    const { onSuccess, actType, record } = this.props
    const fields = await form.current.validateFields()
    const isEdit = actType === 'edit'
    const body = buildAgentBody(fields, isEdit)

    try {
      if (isEdit) {
        const id = record?.id
        if (id == null) {
          message.error('缺少管理员 id')
          throw new Error('缺少管理员 id')
        }
        await updateSystemAgent(id, body)
        message.success('保存成功')
      } else {
        await createSystemAgent(body)
        message.success('创建成功')
      }
      if (typeof onSuccess === 'function') {
        onSuccess()
      }
    } catch (e) {
      const msg =
        e?.response?.data?.msg ||
        e?.response?.data?.message ||
        e?.message ||
        e?.msg ||
        (isEdit ? '保存失败' : '创建失败')
      message.error(typeof msg === 'string' ? msg : '操作失败')
      throw e
    }
  }

  render() {
    const { children, baseProps, title, width: widthProp, actType, record } = this.props
    const { drawerWidth } = this.state
    const width = widthProp !== undefined ? widthProp : drawerWidth
    const drawerTitle =
      title !== undefined && title !== null
        ? title
        : actType === 'edit'
          ? '编辑管理员'
          : '新增管理员'

    const mergedBaseProps =
      actType === 'edit'
        ? { ...baseProps, actType, initialRecord: record }
        : { ...baseProps, actType }

    return (
      <WrappedDrawer
        children={children}
        title={drawerTitle}
        width={width}
        baseComponent={<AgentForm />}
        baseProps={mergedBaseProps}
        onOk={this.handleOk}
        bodyStyle={{
          padding: '12px 16px 72px'
        }}
      />
    )
  }
}

export default AgentDrawer
